import { useState } from 'react';
import type { ChatProspectStage } from '@/types';

export interface ManagerProspectFilters {
  repFilter: string[];
  stageFilter: ChatProspectStage[];
  toggleRep: (repUUID: string) => void;
  toggleStage: (stage: ChatProspectStage) => void;
}

const toggle = <TValue extends string>(
  values: TValue[],
  value: TValue,
): TValue[] =>
  values.includes(value)
    ? values.filter((existing) => existing !== value)
    : [...values, value];

export const useManagerProspectFilters = (): ManagerProspectFilters => {
  const [repFilter, setRepFilter] = useState<string[]>([]);
  const [stageFilter, setStageFilter] = useState<ChatProspectStage[]>([]);

  return {
    repFilter,
    stageFilter,
    toggleRep: (repUUID: string) =>
      setRepFilter((current) => toggle(current, repUUID)),
    toggleStage: (stage: ChatProspectStage) =>
      setStageFilter((current) => toggle(current, stage)),
  };
};
